import axios from 'axios';

// 本地
// let baseURL = "http://192.168.6.22:8045/servicezone";
// 内网测试
//let baseURL = "http://13.17.6.146:8080/servicezone";
// 预生产
// let baseURL = "https://hdcs.gsxt.gov.cn/servicezone";
// 生产
let baseURL = "https://zzapp.gsxt.gov.cn/servicezone";

// 菜单-执照亮照 内网测试 跳转地址
// const businessshowurl = "http://13.17.6.142:8081/businessShow/";
const businessshowurl = "https://zzlz.gsxt.gov.cn/businessShow/";

const request = () => {
	return axios.create({
		baseURL: baseURL,
		timeout: 50000,
		cache:false,
		headers: {
			// "Access-Control-Allow-Origin": '*',
			// "Access-Control-Allow-Headers": 'X-Requested-With,Content-Type',
			// "Access-Control-Allow-Methods": 'PUT,POST,GET,DELETE,OPTIONS',
		}
	});
}


function Get(url, data={}, callback,config={}) {
	request().get( url + "?" + Date.parse(new Date()), data,config).then(({data}) => {
		
		callback && callback(data);
    }).catch(err=>{
		console.log(err)
	})
}

function Post(url, data = {}, callback,config = {}) {
    request().post(url + "?" + Date.parse(new Date()), data,config).then(({data}) => {
		callback && callback(data);
	}).catch(err => {
		console.log(err)
	})
}

function Delete(url, data={}, callback,config={}) {
	request().delete( url + "?" + Date.parse(new Date()), data, config ).then(({data}) => {
		callback && callback(data);
    }).catch(err=>{
		console.log(err)
	})
}

function Put(url, data={}, callback,config={}) {
	request().put( url + "?" + Date.parse(new Date()), data, config )
	.then(({data}) => {
		callback && callback(data);
	}).catch(err=>{
		console.log(err)
	})
}

function upLoadFile (url , data, callback1, callback2, callback3 ) {
	
    axios({
        url: baseURL + url,
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: function (progressEvent) { //原生获取上传进度的事件
        	console.log(progressEvent)
            if (progressEvent.lengthComputable) {
                //属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
                //如果lengthComputable为false，就获取不到progressEvent.total和progressEvent.loaded
                callback1(progressEvent);
            }
        },
        data: data
    }).then(res => {
    	console.log(res)
        callback2(res.data);
    }).then(error => {
        callback3(error)
    })
}

function downloadFile (url , data, callback1, callback2 ) {
	
    axios({
        url: baseURL + url,
        method: 'post',
        responseType: 'blob',
        data
    }).then(res => {
    	console.log(res)
        callback1(res.data);
    }).then(error => {
        callback2(error)
    })
}

export {
	Get,
	Post,
	Delete,
	Put,
	baseURL,
	upLoadFile,
	downloadFile,
	businessshowurl
}
